import React from 'react';
import TablePage from '../../../../../components/pages/TablePage';
import moment from 'moment';
export default () => {
    const columns = [
        {
            selector: (row) => row?.kode_warehouse,
            name: "Kode Warehouse",
            id: 'kode_warehouse',
            width: "150px"
        },
        {
            selector: (row) => row?.nama,
            name: "Nama",
            id: 'nama'
        },
        {
            selector: (row) => row?.kode_tps,
            name: "Kode TPS",
            id: 'kode_tps',
            width: "120px"
        },
        {
            selector: (row) => row?.address,
            name: "Address",
            id: 'address'
        },
        {
            selector: (row) => (row?.createdAt && moment(row.createdAt).format('DD-MMM-YYYY')) || '-',
            name: "CreatedAt",
            id: 'created_at'
        },
    ]
    return (
        <TablePage
            title={"Master Warehouse"}
            url="api/v1/warehouse"
            actionPosition={'first'}
            createPath="/master/warehouse/create"
            editPath={"/master/warehouse/edit"}
            columns={columns}
        />
    )
}
